<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">PLANSKA KALKULACIJA - Izračun cijene koštanja</h2>

  <div class="content-block">
    <div class="card">
      <div class="card-item">
        <h3><span>Plan:</span> {{ idPlan }}</h3>
        <h3><span>Radni nalog:</span> {{ plan.rnBroj }}</h3>
      </div>
      <div class="card-item">
        <h3><span>Komada:</span> {{ plan.kolicina }}</h3>
        <h3><span>Datum:</span> {{ plan.datum }}</h3>
      </div>
      <div class="card-item">
        <h3>
          <span>{{ plan.sifra }}</span> {{ plan.proizvod }}
        </h3>
      </div>
      <div class="card-item">
        <h3><span>Linija:</span> {{ plan.linija }}</h3>
      </div>
      <div class="card-item">
        <h3><span>Smjena:</span> {{ plan.smjenaId }}</h3>
      </div>
      <!-- <div class="card-item">
      <h3><span>Tura:</span></h3>
      <dx-number-box [width]="100" [(value)]="brojTura"></dx-number-box>
    </div> -->
      <div class="card-item">
        <h3><span>Cijena KW po minuti:</span></h3>
        <dx-number-box [width]="100" [(value)]="cijenaStruja"></dx-number-box>
      </div>
      <div class="card-item">
        <h3>
          <span>Cijena plina za m<span class="numberSuper">3</span>:</span>
        </h3>
        <dx-number-box [width]="100" [(value)]="cijenaPlin"></dx-number-box>
      </div>
      <div class="card-item">
        <h3>
          <span>Cijena vode za m<span class="numberSuper">3</span>:</span>
        </h3>
        <dx-number-box [width]="100" [(value)]="cijenaVoda"></dx-number-box>
      </div>
      <div class="card-item">
        <h3><span>OTP u EUR po minuti:</span></h3>
        <dx-number-box [width]="100" [(value)]="cijenaOTP"></dx-number-box>
      </div>
      <div class="card-item">
        <dx-button
          [width]="160"
          stylingMode="outlined"
          type="danger"
          text="OBRAČUNAJ"
          (click)="obracunaj()"
        ></dx-button>
      </div>
    </div>
    <div class="card-right" *ngIf="troskovnik">
      <h6 class="m-0">Planirano</h6>
      <div>
        Procesi:
        <span class="suma">{{
          troskovnik.pkus_procesi | currency : "" : ""
        }}</span>
      </div>
      <div>
        Amortizacija:
        <span class="suma">{{
          troskovnik.pkus_amortizacija | currency : "" : ""
        }}</span>
      </div>
      <div>
        Struja:
        <span class="suma">{{
          troskovnik.pkus_struja | currency : "" : ""
        }}</span>
      </div>
      <div>
        Plin:
        <span class="suma">{{
          troskovnik.pkus_plin | currency : "" : ""
        }}</span>
      </div>
      <div>
        Voda:
        <span class="suma">{{
          troskovnik.pkus_voda | currency : "" : ""
        }}</span>
      </div>
      <div>
        Normativi:
        <span class="suma">{{
          troskovnik.pkus_normativ | currency : "" : ""
        }}</span>
      </div>
      <div>
        OTP:
        <span class="suma">{{ troskovnik.pkus_otp | currency : "" : "" }}</span>
      </div>
      <div>
        <strong>UKUPNO:</strong>
        <span class="sumaBold">{{
          troskovnik.pkus_ukupno | currency : "" : ""
        }}</span>
      </div>
      <div>
        <strong>CIJENA PO KOMADU:</strong>
        <span class="sumaBold">{{
          troskovnik.pkus_cijenapokomadu | currency : "" : ""
        }}</span>
      </div>
    </div>
    <div class="card-right" style="margin-left: 2rem" *ngIf="troskovnik">
      <h6 class="m-0">Ostvareno</h6>
      <div>
        Procesi:
        <span class="suma">{{
          troskovnik.pkus_procesi_edit | currency : "" : ""
        }}</span>
      </div>
      <div>
        Amortizacija:
        <span class="suma">{{
          troskovnik.pkus_amortizacija_edit | currency : "" : ""
        }}</span>
      </div>
      <div>
        Struja:
        <span class="suma">{{
          troskovnik.pkus_struja_edit | currency : "" : ""
        }}</span>
      </div>
      <div>
        Plin:
        <span class="suma">{{
          troskovnik.pkus_plin_edit | currency : "" : ""
        }}</span>
      </div>
      <div>
        Voda:
        <span class="suma">{{
          troskovnik.pkus_voda_edit | currency : "" : ""
        }}</span>
      </div>
      <div>
        Normativi:
        <span class="suma">{{
          troskovnik.pkus_normativ_edit | currency : "" : ""
        }}</span>
      </div>
      <div>
        OTP:
        <span class="suma">{{
          troskovnik.pkus_otp_edit | currency : "" : ""
        }}</span>
      </div>
      <div>
        <strong>UKUPNO:</strong>
        <span class="sumaBold">{{
          troskovnik.pkus_ukupno_edit | currency : "" : ""
        }}</span>
      </div>
      <div>
        <strong>CIJENA PO KOMADU:</strong>
        <span class="sumaBold">{{
          troskovnik.pkus_cijenapokomadu_edit | currency : "" : ""
        }}</span>
      </div>
    </div>
  </div>

  <div class="content-block">
    <dx-tabs
      [dataSource]="tabs"
      [selectedIndex]="0"
      (onItemClick)="selectTab($event)"
    ></dx-tabs>
  </div>

  <div *ngIf="isLoading" class="content-block">Učitavanje tablice...</div>
  <div *ngIf="!isLoading" class="content-block mt-0 tablicaPlanska">
    <div *ngIf="prikaziTablicuProcesi">
      <!-- 
      (onRowUpdated)="urediProces($event)"
      (onRowRemoved)="obrisiProces($event)"
    > -->
      <dx-data-grid
        [dataSource]="procesi"
        [wordWrapEnabled]="true"
        [showColumnLines]="true"
        keyExpr="id"
        [columnAutoWidth]="true"
        [columnMinWidth]="60"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowUpdated)="urediProces($event)"
        (onCellPrepared)="onCellPreparedProcesi($event)"
      >
        <div *dxTemplate="let data of 'headerRight'">
          <div class="d-inline ml-15">
            <dx-button
              icon="plus"
              stylingMode="outlined"
              type="normal"
              (click)="dodajProcesPopup()"
            >
            </dx-button>
          </div>
        </div>

        <dxo-editing
          mode="batch"
          [allowUpdating]="true"
          [allowDeleting]="false"
          [selectTextOnEditStart]="true"
          [startEditAction]="'click'"
        >
        </dxo-editing>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxo-scrolling
          columnRenderingMode="virtual"
          [showScrollbar]="'always'"
        ></dxo-scrolling>

        <dxi-column
          cellTemplate="aktivan"
          [width]="60"
          [fixed]="true"
          fixedPosition="left"
        >
          <div *dxTemplate="let data of 'aktivan'">
            <dx-button
              icon="{{ data.data.aktivan ? 'isnotblank' : 'isblank' }}"
              (onClick)="toggleStatus(data)"
            ></dx-button>
          </div>
        </dxi-column>
        <dxi-column
          dataField="aktivan"
          caption=""
          [visible]="false"
        ></dxi-column>
        <dxi-column
          dataField="naziv"
          caption="Proces"
          [allowEditing]="false"
          [minWidth]="200"
          [fixed]="true"
          fixedPosition="left"
        ></dxi-column>
        <dxi-column
          dataField="vtoum"
          caption="Vrijeme trajanja operacije u minutama"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="vtcpum"
          caption="Vrijeme trajanja cijelog procesa u minutama"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="vrrum"
          caption="Vrijeme rada radnika u minutama"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="brno"
          caption="Broj radnika na operaciji"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="vsrno"
          caption="Vrijeme svih radnika na operaciji"
          [width]="150"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="crrum"
          caption="Cijena rada radnika u minuti"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="ucrpo"
          caption="Ukupna cijena rada po operacijama"
          [width]="150"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="napomena"
          caption="Napomena"
          [minWidth]="300"
          alignment="left"
        ></dxi-column>
      </dx-data-grid>

      <dx-popup
        [width]="400"
        [height]="'auto'"
        [showTitle]="true"
        title="Dodaj proces"
        [dragEnabled]="true"
        [closeOnOutsideClick]="false"
        [position]="{ my: 'top', at: 'center top', of: '', offset: '0 200' }"
        [(visible)]="dodajProcesPopupVisible"
      >
        <dx-select-box
          class="mb-20"
          [dataSource]="sviProcesi"
          [(value)]="odabraniProces"
          valueExpr="id"
          displayExpr="ime"
          placeholder="Odaberi proces"
          [searchEnabled]="true"
          [searchExpr]="['ime']"
          (onValueChanged)="odaberiProces($event)"
        >
        </dx-select-box>
        <div class="floating-placeholder">
          <dx-number-box
            class="mb-20"
            placeholder="Vrijeme trajanja operacije u minutama"
            [value]="vtoum"
            (onValueChanged)="onChangeVTOUM($event)"
          >
          </dx-number-box>
        </div>
        <div class="floating-placeholder">
          <dx-number-box
            class="mb-20"
            placeholder="Vrijeme trajanja cijelog procesa u minutama"
            [value]="vtcpum"
            (onValueChanged)="onChangeVTCPUM($event)"
          >
          </dx-number-box>
        </div>
        <div class="floating-placeholder">
          <dx-number-box
            class="mb-20"
            placeholder="Vrijeme rada radnika u minutama"
            [value]="vrrum"
            (onValueChanged)="onChangeVRRUM($event)"
          >
          </dx-number-box>
        </div>
        <div class="floating-placeholder">
          <dx-number-box
            class="mb-20"
            placeholder="Broj radnika na operaciji"
            [value]="brno"
            (onValueChanged)="onChangeBRNO($event)"
          >
          </dx-number-box>
        </div>
        <div class="floating-placeholder">
          <dx-number-box
            class="mb-20"
            placeholder="Cijena rada radnika u minuti"
            [value]="crrum"
            (onValueChanged)="onChangeCRRUM($event)"
          >
          </dx-number-box>
        </div>
        <div class="floating-placeholder">
          <dx-text-area
            class="mb-20"
            placeholder="Napomena"
            [value]="napomena"
            (onValueChanged)="onChangeNapomena($event)"
          >
          </dx-text-area>
        </div>

        <dx-button
          [disabled]="!odabraniProces"
          class="popupButton"
          text="Dodaj"
          stylingMode="outlined"
          type="danger"
          (onClick)="dodajProces()"
        >
        </dx-button>
      </dx-popup>
    </div>

    <div *ngIf="prikaziTablicuStrojevi">
      <!-- 
      (onRowUpdated)="spremiPromjene($event)"
      (onRowRemoved)="obrisiStrojSaLinije($event)"
    > -->
      <dx-data-grid
        [dataSource]="strojevi"
        [wordWrapEnabled]="true"
        keyExpr="id"
        [columnAutoWidth]="true"
        [columnMinWidth]="60"
        [showColumnLines]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowUpdated)="urediStroj($event)"
        (onCellPrepared)="onCellPreparedStrojevi($event)"
      >
        <div *dxTemplate="let data of 'headerRight'">
          <div class="d-inline ml-15">
            <dx-button
              icon="plus"
              stylingMode="outlined"
              type="normal"
              (click)="dodajStrojPopup()"
            >
            </dx-button>
          </div>
        </div>

        <dxo-editing
          mode="batch"
          [allowUpdating]="true"
          [allowDeleting]="false"
          [selectTextOnEditStart]="true"
          [startEditAction]="'click'"
        >
        </dxo-editing>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxo-scrolling
          columnRenderingMode="virtual"
          [showScrollbar]="'always'"
        ></dxo-scrolling>

        <dxi-column
          cellTemplate="aktivan"
          [width]="60"
          [fixed]="true"
          fixedPosition="left"
        >
          <div *dxTemplate="let data of 'aktivan'">
            <dx-button
              icon="{{ data.data.aktivan ? 'isnotblank' : 'isblank' }}"
              (onClick)="toggleStatus(data)"
            ></dx-button>
          </div>
        </dxi-column>
        <dxi-column
          dataField="aktivan"
          caption=""
          [visible]="false"
        ></dxi-column>
        <dxi-column
          dataField="naziv"
          caption="Naziv stroja"
          [allowEditing]="false"
          [minWidth]="300"
          [fixed]="true"
          fixedPosition="left"
        ></dxi-column>
        <dxi-column
          dataField="amortizacija"
          caption="Amortizacija po minuti"
          alignment="center"
          [minWidth]="100"
        ></dxi-column>
        <dxi-column
          dataField="potrosnjaStruje"
          caption="Potrošnja struje na stroju KW/m"
          alignment="center"
          [minWidth]="100"
        ></dxi-column>
        <dxi-column
          dataField="struja"
          caption="Cijena struje na stroju"
          [allowEditing]="false"
          alignment="center"
          [minWidth]="100"
        ></dxi-column>
        <dxi-column
          dataField="potrosnjaPlina"
          caption="Potrošnja plina na stroju m3"
          alignment="center"
          [minWidth]="100"
        ></dxi-column>
        <dxi-column
          dataField="plin"
          caption="Cijena plina na stroju"
          [allowEditing]="false"
          alignment="center"
          [minWidth]="100"
        ></dxi-column>
        <dxi-column
          dataField="potrosnjaVode"
          caption="Potrošnja vode na stroju m3"
          alignment="center"
          [minWidth]="100"
        ></dxi-column>
        <dxi-column
          dataField="voda"
          caption="Cijena vode na stroju"
          [allowEditing]="false"
          alignment="center"
          [minWidth]="100"
        ></dxi-column>
        <!-- <dxi-column dataField="ulaznaFaktura" caption="Ulazna faktura" alignment="center" [minWidth]="100"></dxi-column> -->
        <dxi-column
          dataField="idProces"
          caption="Povezano sa procesom"
          [minWidth]="200"
          alignment="left"
        >
          <dxo-lookup
            [dataSource]="sviProcesi"
            valueExpr="id"
            displayExpr="ime"
          ></dxo-lookup>
        </dxi-column>
        <dxi-column
          dataField="napomena"
          caption="Napomena"
          [minWidth]="300"
          alignment="left"
        ></dxi-column>
      </dx-data-grid>

      <dx-popup
        [width]="500"
        [height]="'auto'"
        [showTitle]="true"
        title="Dodaj stroj"
        [dragEnabled]="true"
        [closeOnOutsideClick]="false"
        [position]="{ my: 'top', at: 'center top', of: '', offset: '0 200' }"
        [(visible)]="dodajStrojPopupVisible"
      >
        <dx-select-box
          class="mb-20"
          [dataSource]="sviStrojevi"
          [(value)]="odabraniStroj"
          valueExpr="id"
          displayExpr="sifraIme"
          placeholder="Odaberi stroj"
          [searchEnabled]="true"
          [searchExpr]="['ime']"
          (onValueChanged)="odaberiStroj($event)"
        >
        </dx-select-box>
        <dx-select-box
          class="mb-20"
          [dataSource]="sviProcesi"
          [(value)]="odabraniProces"
          valueExpr="id"
          displayExpr="ime"
          placeholder="Poveži stroj sa procesom"
          [searchEnabled]="true"
          [searchExpr]="['ime']"
          (onValueChanged)="odaberiProcesStroj($event)"
        >
        </dx-select-box>
        <div class="floating-placeholder">
          <dx-number-box
            class="mb-20"
            placeholder="Amortizacija po minuti"
            [value]="stroj.amortizacija"
            (onValueChanged)="onChangeAmortizacija($event)"
          >
          </dx-number-box>
        </div>
        <div class="floating-placeholder">
          <dx-number-box
            class="mb-20"
            placeholder="Potrošnja struje na stroju KW/m"
            [value]="stroj.potrosnjaStruje"
            (onValueChanged)="onChangePotrosnjaStruje($event)"
          >
          </dx-number-box>
        </div>
        <!-- <div class="floating-placeholder">
        <dx-number-box
          class="mb-20"
          placeholder="Struja - stroj"
          [value]="stroj.struja"
          (onValueChanged)="onChangeStruja($event)">
        </dx-number-box>
      </div> -->
        <div class="floating-placeholder">
          <dx-number-box
            class="mb-20"
            placeholder="Potrošnja plina na stroju m3"
            [value]="stroj.potrosnjaPlina"
            (onValueChanged)="onChangePotrosnjaPlina($event)"
          >
          </dx-number-box>
        </div>
        <!-- <div class="floating-placeholder">
        <dx-number-box
          class="mb-20"
          placeholder="Plin - stroj"
          [value]="stroj.plin"
          (onValueChanged)="onChangePlin($event)">
        </dx-number-box>
      </div> -->
        <div class="floating-placeholder">
          <dx-number-box
            class="mb-20"
            placeholder="Potrošnja vode na stroju m3"
            [value]="stroj.potrosnjaVode"
            (onValueChanged)="onChangePotrosnjaVode($event)"
          >
          </dx-number-box>
        </div>
        <!-- <div class="floating-placeholder">
        <dx-number-box
          class="mb-20"
          placeholder="Voda - stroj"
          [value]="stroj.voda"
          (onValueChanged)="onChangeVoda($event)">
        </dx-number-box>
      </div> -->
        <!-- <div class="floating-placeholder">
        <dx-number-box
          class="mb-20"
          placeholder="Ulazna faktura"
          [value]="stroj.ulaznaFaktura"
          (onValueChanged)="onChangeUlaznaFaktura($event)">
        </dx-number-box>
      </div> -->
        <div class="floating-placeholder">
          <dx-text-area
            class="mb-20"
            placeholder="Napomena"
            [value]="napomena"
            (onValueChanged)="onChangeNapomena($event)"
          >
          </dx-text-area>
        </div>

        <dx-button
          [disabled]="!odabraniStroj"
          class="popupButton"
          text="Dodaj"
          stylingMode="outlined"
          type="danger"
          (onClick)="dodajStroj()"
        >
        </dx-button>
      </dx-popup>
    </div>

    <div *ngIf="prikaziTablicuNormativi">
      <dx-data-grid
        class="planskaPadding"
        [dataSource]="normativi"
        [wordWrapEnabled]="true"
        [showColumnLines]="true"
        keyExpr="id"
        (onRowUpdated)="urediNormativ($event)"
      >
        <!-- 
      (onToolbarPreparing)="onToolbarPreparing($event)"
      (onEditorPreparing)="onEditorPreparing($event)"
     -->
        <!-- <div *dxTemplate="let data of 'headerRight'">
        <div class="d-inline ml-15">
          <dx-button
            icon="plus"
            stylingMode="outlined"
            type="normal"
            (click)="dodajDjelatnikaPopup()">
          </dx-button>
        </div>
      </div> -->
        <dxo-editing
          mode="batch"
          [allowUpdating]="false"
          [allowDeleting]="false"
          [selectTextOnEditStart]="true"
          [startEditAction]="'click'"
        >
        </dxo-editing>
        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column
          dataField="sifra"
          caption="Šifra"
          alignment="center"
          [width]="150"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="naziv"
          caption="Naziv"
          [width]="300"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="jedinicaMjere"
          caption="Jedinica mjere"
          alignment="left"
          [width]="100"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="ukupnaKolicina"
          caption="Količina neto po normativu"
          alignment="right"
          [width]="110"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="ukupnoUtrosenaKolicina"
          caption="Ukupno utrošena količina"
          alignment="right"
          [width]="120"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="cijena"
          caption="Jedinična cijena"
          alignment="right"
          [width]="130"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="ukupnaCijenaPrikaz"
          caption="Ukupna vrijednost"
          alignment="right"
          [width]="130"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField=""
          caption=""
          alignment="left"
          [minWidth]="130"
        ></dxi-column>
      </dx-data-grid>
    </div>

    <div *ngIf="prikaziTablicuDjelatnici">
      <dx-data-grid
        [dataSource]="djelatnici"
        [wordWrapEnabled]="true"
        [showColumnLines]="true"
        keyExpr="id"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onEditorPreparing)="onEditorPreparing($event)"
        (onRowUpdated)="urediDjelatnika($event)"
      >
        <div *dxTemplate="let data of 'headerRight'">
          <div class="d-inline ml-15">
            <dx-button
              icon="plus"
              stylingMode="outlined"
              type="normal"
              (click)="dodajDjelatnikaPopup()"
            >
            </dx-button>
          </div>
        </div>

        <dxo-editing
          mode="batch"
          [allowUpdating]="true"
          [allowDeleting]="false"
          [selectTextOnEditStart]="true"
          [startEditAction]="'click'"
        >
        </dxo-editing>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column cellTemplate="aktivan" [width]="60">
          <div *dxTemplate="let data of 'aktivan'">
            <dx-button
              icon="{{ data.data.aktivan ? 'isnotblank' : 'isblank' }}"
              (onClick)="toggleStatus(data)"
            ></dx-button>
          </div>
        </dxi-column>
        <dxi-column dataField="aktivan" caption="" [width]="0"></dxi-column>
        <dxi-column
          dataField="pocetak"
          caption="Početak"
          alignment="center"
          [width]="80"
        ></dxi-column>
        <dxi-column
          dataField="kraj"
          caption="Kraj"
          alignment="center"
          [width]="80"
        ></dxi-column>
        <dxi-column
          dataField="vrijemeRada"
          caption="Vrijeme rada"
          alignment="center"
          [width]="80"
        ></dxi-column>
        <dxi-column
          dataField="ime"
          caption="Djelatnik"
          [width]="300"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="napomena"
          caption="Napomena"
          [minWidth]="300"
          alignment="left"
        ></dxi-column>
      </dx-data-grid>

      <dx-popup
        [width]="400"
        [height]="'auto'"
        [showTitle]="true"
        title="Dodaj djelatnika"
        [dragEnabled]="true"
        [closeOnOutsideClick]="false"
        [position]="{ my: 'top', at: 'center top', of: '', offset: '0 200' }"
        [(visible)]="dodajDjelatnikaPopupVisible"
      >
        <dx-select-box
          class="mb-10"
          [dataSource]="sviDjelatnici"
          [(value)]="odabraniDjelatnik"
          valueExpr="ime"
          displayExpr="ime"
          placeholder="Odaberi djelatnika"
          [searchEnabled]="true"
          [searchExpr]="['ime']"
          (onValueChanged)="odaberiDjelatnika($event)"
        >
        </dx-select-box>
        <div class="grid-2-column mb-10">
          <dx-date-box
            type="time"
            placeholder="Početak"
            interval="60"
            [useMaskBehavior]="true"
            displayFormat="HH:mm"
            [(value)]="pocetak"
            (onValueChanged)="promjeniPocetak($event)"
          >
          </dx-date-box>
          <dx-date-box
            type="time"
            placeholder="Kraj"
            interval="60"
            [useMaskBehavior]="true"
            displayFormat="HH:mm"
            [(value)]="kraj"
            (onValueChanged)="promjeniKraj($event)"
          >
          </dx-date-box>
        </div>
        <dx-text-area
          class="mb-20"
          placeholder="Napomena"
          [value]="napomena"
          (onValueChanged)="onChangeNapomena($event)"
        ></dx-text-area>

        <dx-button
          [disabled]="!odabraniDjelatnik"
          class="popupButton"
          text="Dodaj"
          stylingMode="outlined"
          type="danger"
          (onClick)="dodajDjelatnika()"
        ></dx-button>
      </dx-popup>
    </div>

    <!-- ========== TABLICA OTP ========== -->
    <div *ngIf="prikaziTablicuOTP">
      <dx-data-grid
        class="planskaPadding"
        [showColumnLines]="true"
        [dataSource]="ostaliTroskovi"
        [wordWrapEnabled]="true"
        keyExpr="id"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onRowUpdated)="urediOTP($event)"
        (onRowRemoved)="obrisiOTP($event)"
        (onCellPrepared)="onCellPreparedOTP($event)"
      >
        <div *dxTemplate="let data of 'headerRight'">
          <div class="d-inline ml-15">
            <dx-button
              icon="plus"
              stylingMode="outlined"
              type="normal"
              (click)="dodajOTPPopup()"
            ></dx-button>
          </div>
        </div>

        <dxo-editing
          mode="batch"
          [allowUpdating]="true"
          [allowDeleting]="true"
          [selectTextOnEditStart]="true"
          [startEditAction]="'click'"
        >
        </dxo-editing>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxi-column
          dataField="naziv"
          caption="Naziv dodatka"
          [minWidth]="300"
          alignment="left"
          [fixed]="true"
          fixedPosition="left"
        ></dxi-column>
        <dxi-column
          dataField="idProces"
          caption="Proces"
          [width]="200"
          alignment="left"
        >
          <dxo-lookup
            [dataSource]="procesi"
            valueExpr="idProces"
            displayExpr="naziv"
          ></dxo-lookup>
        </dxi-column>
        <dxi-column
          dataField="idStroj"
          caption="Stroj"
          [width]="300"
          alignment="left"
        >
          <dxo-lookup
            [dataSource]="strojevi"
            valueExpr="id"
            displayExpr="naziv"
          ></dxo-lookup>
        </dxi-column>
        <dxi-column
          dataField="ukupnoDodatak"
          caption="Ukupno dodatak"
          [width]="100"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="cijena"
          caption="Cijena dodatka po minuti"
          [width]="150"
          alignment="center"
        ></dxi-column>
        <dxi-column
          dataField="ukupnoEkstraDodatak"
          caption="Ukupno ekstra dodatak"
          [width]="150"
          alignment="center"
          [allowEditing]="false"
        ></dxi-column>
        <dxi-column
          dataField="napomena"
          caption="Napomena"
          [minWidth]="300"
          alignment="left"
        ></dxi-column>
      </dx-data-grid>

      <dx-popup
        [width]="400"
        [height]="'auto'"
        [showTitle]="true"
        title="Dodaj OTP"
        [dragEnabled]="true"
        [closeOnOutsideClick]="false"
        [position]="{ my: 'top', at: 'center top', of: '', offset: '0 200' }"
        [(visible)]="dodajOTPPopupVisible"
      >
        <div class="floating-placeholder">
          <dx-select-box
            class="mb-20"
            [dataSource]="procesi"
            [(value)]="odabraniProces"
            valueExpr="idProces"
            displayExpr="naziv"
            placeholder="Pripadajući proces"
            [searchEnabled]="true"
            [searchExpr]="['naziv']"
            (onValueChanged)="odaberiProcesOTP($event)"
          >
          </dx-select-box>
        </div>
        <div class="floating-placeholder">
          <dx-select-box
            class="mb-20"
            [dataSource]="strojevi"
            [(value)]="odabraniStroj"
            valueExpr="id"
            displayExpr="naziv"
            placeholder="Pripadajući stroj"
            [searchEnabled]="true"
            [searchExpr]="['naziv']"
            (onValueChanged)="odaberiStrojOTP($event)"
          >
          </dx-select-box>
        </div>
        <div class="floating-placeholder">
          <dx-text-box
            class="mb-20"
            placeholder="Naziv dodatka"
            [value]="nazivDodatka"
            (onValueChanged)="onChangeNazivDodatka($event)"
          >
          </dx-text-box>
        </div>
        <div class="floating-placeholder">
          <dx-number-box
            class="mb-20"
            placeholder="{{
              odabraniStroj ? 'Cijena dodatka po minuti' : 'Cijena dodatka'
            }}"
            [value]="cijenaDodatka"
            (onValueChanged)="onChangeCijenaDodatka($event)"
          ></dx-number-box>
        </div>
        <div class="floating-placeholder">
          <dx-text-area
            class="mb-20"
            placeholder="Napomena"
            [value]="napomena"
            (onValueChanged)="onChangeNapomena($event)"
          >
          </dx-text-area>
        </div>

        <dx-button
          [disabled]="!odabraniProces"
          class="popupButton"
          text="Dodaj"
          stylingMode="outlined"
          type="danger"
          (onClick)="dodajOTP()"
        >
        </dx-button>
      </dx-popup>
    </div>
    <!-- TABLICA NAPOMENA I SLIKE -->
    <div *ngIf="prikaziTablicuNapomenaiSlike">
      <div>
        <dx-data-grid
          class="planskaPadding"
          [dataSource]="sviDokumenti"
          [showColumnLines]="true"
          [wordWrapEnabled]="true"
          keyExpr="iduploaddokument"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onRowRemoved)="obrisiDokument($event)"
        >
          <div *dxTemplate="let data of 'headerRight'">
            <div class="d-inline ml-15">
              <dx-button
                icon="plus"
                stylingMode="outlined"
                type="normal"
                (click)="clickFileUploader()"
              ></dx-button>
              <!-- <dx-file-uploader
              selectButtonText="+"
              labelText=""
              accept=".jpg, .pdf, .doc, .docx, .xls, .xlsx"
              uploadMode="instantly"
              [uploadUrl]="upload_URL"
              (onUploaded)="uploadDoc($event)">
            </dx-file-uploader> -->
            </div>
          </div>

          <dxo-editing
            mode="batch"
            [allowUpdating]="false"
            [allowDeleting]="true"
            [selectTextOnEditStart]="true"
            [startEditAction]="'click'"
          >
          </dxo-editing>

          <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
          <dxo-pager
            [showPageSizeSelector]="true"
            [allowedPageSizes]="[10, 20, 30]"
            [showInfo]="true"
          >
          </dxo-pager>

          <dxi-column
            dataField="redni_broj"
            caption="Rb."
            [width]="70"
            [formItem]="{ visible: false }"
            [allowEditing]="false"
          ></dxi-column>
          <dxi-column caption="Naziv" cellTemplate="slikaa">
            <div *dxTemplate="let data of 'slikaa'">
              <a
                class="slika"
                href="{{
                  URL
                }}/dokumentiplanskakalkulacija/planskakalkulacija/URL={{
                  data.data.ud_putanja
                }}?access_token={{ token }}"
                target="_blank"
                title="Pogledaj"
                >{{ data.data.ud_nazivdokumenta_orig }}</a
              >
            </div>
          </dxi-column>
        </dx-data-grid>
      </div>
      <div>
        <div class="textarea">
          <span><b>NAPOMENA:</b></span>
          <dx-text-area
            placeholder="Napišite napomenu..."
            [height]="90"
            [maxLength]="500"
            [(value)]="napomena_komentar"
          ></dx-text-area>
        </div>
        <dx-button
          text="Spremi"
          type="success"
          class="edit"
          (onClick)="dodajNapomenu(napomena_komentar)"
        ></dx-button>
      </div>

      <div style="visibility: hidden">
        <input
          type="file"
          id="kliknagumb"
          (change)="fileChangeDoc($event)"
          placeholder="Upload file"
          accept=".jpg, .pdf, .doc, .docx, .xls, .xlsx"
        />
      </div>
    </div>
  </div>
</div>
